'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";

class jsDataProvider
{
	constructor(){
		this.data = {};
		this.is_data = false;
		if(typeof(jsData) !== 'undefined'){
			this.data = jsData;
			this.is_data = true;
		}
	}

	isData(){
		return this.is_data;
	}

	getAllData(){
		return this.data;
	}

	get(key){
		if(typeof(this.data[key]) !== 'undefined'){
			return this.data[key];
		}
		if(arguments.length > 1){
			return arguments[1];
		}
		return null;
	}
	
	set(key, value){
		this.data[key] = value;
	}
}

EwSiteApp.factory('jsDataService', function(){
	return new jsDataProvider();
});
